import{styled as r}from"@mui/material/styles";import d from"@mui/material/Chip";export*from"@mui/material/Chip";const e=r(d,{shouldForwardProp:o=>o!=="squared"})(({squared:o=!1})=>({borderRadius:o?6:void 0}));export{e as default};
